// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__ftIxy","logoContainer":"Sidebar_logoContainer__hA7Gm","logo":"Sidebar_logo__ojvK4","navLink":"Sidebar_navLink__NnH57","active":"Sidebar_active__lIwRs"};